const environment={apiPrefix:"https://api-test.backoffice.parnanoronha.nscreen.com.br",enableMock:false};export default environment;